import { Icon, Text, VStack } from '@chakra-ui/react';
import { IoWater } from 'react-icons/io5';

import { JournalEntryCard } from '../JournalEntryCard/JournalEntryCard';
import { WaterIntakeJournalEntry } from '../types';

export interface WaterIntakeEntryCardProps {
  entry: WaterIntakeJournalEntry;
}

/**
 * Displays a water intake journal entry with amount and unit.
 */
export const WaterIntakeEntryCard: React.FC<WaterIntakeEntryCardProps> = ({
  entry,
}) => {
  const hasAmount = entry.amount !== null && entry.amount !== undefined;

  return (
    <JournalEntryCard
      entryId={entry.id}
      icon={<Icon as={IoWater} color="blue.400" boxSize={5} />}
      title={
        <Text fontSize="sm" fontWeight={600} color="text.default">
          Water
        </Text>
      }
      time={entry.createdAt}
      timezone={entry.timezone}
      comments={entry.comments}
    >
      {({ isExpanded: expanded }) => (
        <VStack align="stretch" spacing={2}>
          {/* Amount (always visible) */}
          {hasAmount && (
            <Text fontSize="lg" fontWeight={600} color="blue.500">
              {entry.amount} {entry.unit}
            </Text>
          )}

          {/* Expanded Content */}
          {expanded && entry.description && (
            <Text fontSize="sm" color="text.default">
              {entry.description}
            </Text>
          )}
        </VStack>
      )}
    </JournalEntryCard>
  );
};

WaterIntakeEntryCard.displayName = 'WaterIntakeEntryCard';
